import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Label } from 'rbx';
import { toast } from 'react-toastify';

// import gql from 'graphql-tag';
// import uuidv4 from 'uuid/v4';
// import { differenceBy } from 'lodash';
// import client from '../../../utils/apolloClient';

import { CheckBox, Loading, Select } from '../../../components/elements';
import { getAllCategories } from '../../MenuManagement/Menu/Designer/helpers';
import DiscountValueInput from './ItemsAndVariantsDiscount/DiscountValueInput';

const Container = styled.div`
  &&& {
    .modal-background {
      background-color: rgba(13, 13, 13, 0.28);
    }
    .modal-card-body {
      height: 100vh;
      padding: 0px;
    }
    .modal-card {
      max-height: calc(100vh - 20%);
      position: absolute;
      width: 60%;
    }
    .modal-card-head,
    .modal-card-foot {
      border-top-left-radius: 0px;
      border-top-right-radius: 0px;
    }
    .modal-card-title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .modal-card-head {
      border-bottom: 0px;
      padding: 1.5rem 1rem;
      background: white;
    }
    .modal-card-foot {
      justify-content: flex-end;
      border: 0px;
      padding: 1rem;
      background: white;
    }
    a {
      font-size: 1rem;
    }
  }
`;

const SecondaryHeader = styled.div`
  background: white;
`;
const InputWrapper = styled.div`
  padding: 1rem;
  width: 50%;
`;

const EmptyMessage = styled.div`
  padding: 0 1rem;
  font-size: 12px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-bottom: 2rem;
`;

const discountTypeOptions = [
  { value: 'PERCENTAGE', label: '% rate' },
  { value: 'PRICE', label: 'flat rate' },
];

const AddCategoryModal = ({
  onSubmit,
  isActive,
  onClose,
  initialsItems,
  isSubmitting,
  placeId,
  menuId,
  userId,
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [discountType, setDiscountType] = useState({
    value: 'PERCENTAGE',
    label: '% rate',
  });
  const [discountValue, setDiscountValue] = useState();

  console.log('items123', items, selectedItems);

  const fetchItems = async () => {
    setLoading(true);

    try {
      const res = await getAllCategories({
        place_id: placeId,
        menu_id: menuId,
        user_id: userId,
      });

      const initialItemsSet = new Set(
        initialsItems.map(itm => itm.category_id),
      );

      setItems(res.filter(ele => !initialItemsSet.has(ele.menu_section_id)));

      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
    setSelectedItems([]);
  }, [initialsItems]);

  const addItem = item => {
    setSelectedItems(selectedItems.concat({ ...item }));
  };

  const removeItem = id => {
    setSelectedItems(selectedItems.filter(item => item.menu_section_id !== id));
  };

  return (
    <Container className={`modal ${isActive && 'is-active'}`}>
      <div className="modal-background" />
      <div className="modal-card">
        <header className="modal-card-head">
          <p className="modal-card-title">Add Category(s)</p>
          <button
            type="button"
            className="delete"
            aria-label="close"
            onClick={onClose}
          />
        </header>
        <SecondaryHeader>
          <InputWrapper>
            <GridContainer>
              <Select
                label="Discount Type"
                value={discountType}
                options={discountTypeOptions}
                onChange={value => {
                  setDiscountType(value);
                }}
                isRequired
              />
              <div
                style={{
                  marginTop: 'auto',
                  position: 'relative',
                  bottom: '10px',
                }}
              >
                <Label>Discount Value</Label>
                <DiscountValueInput
                  label="Discount Value"
                  value={discountValue}
                  price=""
                  discountType={discountType?.value}
                  onChange={e => setDiscountValue(e.target.value)}
                />
              </div>
            </GridContainer>
          </InputWrapper>
        </SecondaryHeader>

        <section className="modal-card-body">
          <table style={{ fontSize: '12px' }} className="table is-fullwidth">
            <thead>
              <tr>
                <th />
                <th>
                  <abbr>Name</abbr>
                </th>
                <th>
                  <abbr>Category Id</abbr>
                </th>
                <th>
                  <abbr>Description</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              {!loading &&
                items.map(item => (
                  <tr>
                    <td>
                      <CheckBox
                        value={
                          selectedItems.filter(
                            edge =>
                              edge.menu_section_id === item.menu_section_id,
                          ).length !== 0
                        }
                        onChange={value =>
                          value
                            ? addItem({ ...item })
                            : removeItem(item.menu_section_id)
                        }
                      />
                    </td>
                    <td style={{ fontWeight: '600' }}>{item.name}</td>
                    <td style={{ fontSize: '12px', color: '#737373' }}>
                      {item.menu_section_id}
                    </td>
                    <td>-</td>
                  </tr>
                ))}
            </tbody>
          </table>
          {loading && <Loading />}
          {!loading && items.length === 0 && (
            <EmptyMessage>
              <p>No Categories Found</p>
            </EmptyMessage>
          )}
        </section>
        <footer className="modal-card-foot">
          <button
            type="button"
            className="button is-grey-light"
            aria-label="close"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`button is-primary ${isSubmitting && 'is-loading'}`}
            aria-label="close"
            onClick={async () => {
              if (!discountValue) {
                toast.error('Please enter a discount value!');
                return;
              }

              onSubmit({
                selectedItems,
                discountType: discountType.value,
                discountValue,
              });
            }}
            disabled={selectedItems.length === 0}
          >
            <p className="has-text-weight-semibold">Add Category(s)</p>
          </button>
        </footer>
      </div>
    </Container>
  );
};

export default AddCategoryModal;
